import ReportMediator from './ReportMediator'
import LeaveTypeStore from '../store/LeaveTypeStore'
import LeavesReportStore from './leavesReport/LeavesReportStore'
import _ from 'underscore'
import $ from 'jquery'
import PDFPreviewLightbox from './leavesReport/pdfPreview/PDFPreviewLightbox'
import LeavesReportPDFGenerator from '../pdf/leavesReport/PDFGenerator'
import {ReportType} from './constants'
import ReportPrintableHeadersBuilder from './ReportPrintableHeadersBuilder'
import messageResource from '../messageResource'
import {ReportConfigConstants} from 'constants'
import {Feature, isEnabled} from '../features'
import makeRpcCall from '../util/jquery_rpc'
import {arrayToMap} from '../atUtils'
import LeavesReportEditConfigController from './edit_config_controller/leaves/LeavesReportEditConfigController'
import {downloadPDF} from '../pdf/utils'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'
import {downloadJsonAsCSV} from '../csv/utils'

export default function LeavesReportMediator()
{
    this.constructor = LeavesReportMediator;
}

LeavesReportMediator.prototype = new ReportMediator();

LeavesReportMediator.prototype.init = function(config)
{
    ReportMediator.prototype.init.call(this, config);

    LeaveTypeStore.setLeaveTypes(arrayToMap(config.leavesData));

    this.store = LeavesReportStore;

    const self = this;
    this.ExportSelector = new ExportPanel($("body"), "aTReports.leaveTime.showPDFPreview", "aTReports.leaveTime.createCSV").init();
    this.$exportButton = $(".export");
    this.$exportButton.click(function()
                       {
                           if (!self.$exportButton.hasClass('disabled'))
                               self.ExportSelector.showAt($(this));
                       });

    $(document).on("aTReports.leaveTime.createCSV", function()
    {
        self.generateCSV();
    });

    this.productSettingsValidator = new ATProductSettingsValidator();
    this.reportRightsValidator = new ATReportRightsValidator();

    new BaseReport.PDFPreviewLightboxTemplateView($("body"),
            "leaveTimeAndBalancesPdfPreviewLightbox", "lightboxWithWhiteContent pdfPreviewLightbox noprint").init();

    this.pdfPreviewLightbox = new PDFPreviewLightbox().init(
            {
                popupId: "leaveTimeAndBalancesPdfPreviewLightbox",
                closeBtnId: "closeViewTTPdfPreviewLightboxButton",
                eventNamespace: "leavesReport",
                productSettingsValidator: this.productSettingsValidator,
                reportRightsValidator : this.reportRightsValidator,
            });

    $(document).on("aTReports.leaveTime.showPDFPreview", function()
    {
        self.pdfPreviewLightbox.show();
    });
    $(document).on("leavesReport.pdfPreview.lightbox.hide", function()
    {
        //todo
    });
    $(document).on("leavesReport.pdfPreview.printParametersForSaveChange", function(event, printParametersForSave)
    {
        LeavesReportStore.setPrintParametersForSave(printParametersForSave);
    });
    $(document).on("leavesReport.pdfPreview.printParametersForGenerateChange", function(event, printParametersForGenerate)
    {
        LeavesReportStore.setPrintParametersForGenerate(printParametersForGenerate);
        self.cancelAllPDFExportingProcesses();
        self.generatePDF();
    });
    $(document).on("leavesReport.downloadPDF", function()
    {
        downloadPDF(LeavesReportStore.getGeneratedPDF(), LeavesReportStore.getPDFFileName());
    });

    ATReportsStore.setVisibleUsers(config.users);
    ATReportsStore.setUserGroups(config.userGroups);
    ATReportsStore.setTimeZoneGroups(config.timeZoneGroups);
    
    if (!this.editConfigController.validate())
        this.editConfigController.updateUI(true);

    return this;
};

LeavesReportMediator.prototype.generateCSV = function() {

    const generator = new LeaveCSVJsonConverter().init({
        defaultWorkDayDuration: this.store.getDefaultWorkDayDuration(),
        store: this.store,
        reportParamsStringBuilderConstructor: ATReportParamsStringBuilder,
        manageableUserIds: ATReportsStore.getManageableUserIds(),
        projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    })

    const reportParams = this.store.getReportParams()

    const jsons = generator.getJsons(reportParams, this.store.getReportData())
    const fileName = generator.generateCSVName(reportParams)
    downloadJsonAsCSV(jsons, fileName)
}

LeavesReportMediator.prototype.generatePDF = function() {
    this.pdfGenerator = new LeavesReportPDFGenerator().init({
        store: LeavesReportStore,
        generalStore: ATReportsStore,
        productSettingsValidator: this.productSettingsValidator,
        reportRightsValidator: this.reportRightsValidator,
        manageableUserIds: ATReportsStore.getManageableUserIds(),
        projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
        reportParamsStringBuilderConstructor: ATReportParamsStringBuilder,
    })

    $(document).trigger("leavesReport.pdfGenerator.start");
    const self = this;
    this.pdfGenerator.generatePDF(
            function(config, onDataProvided)
            {
                self.chartController.exportChart(config["chartImageSizes"], function(img)
                {
                    onDataProvided({
                                       chartImage: img
                                   });
                });
            }
    ).then(
            function(pdf)
            {
                LeavesReportStore.setGeneratedPDF(pdf.encodedPDF);
                LeavesReportStore.setPDFFileName(pdf.fileName);
            },
            function(error)
            {
                if (error.message !== "abort")
                {
                    console.error(error);
                }
            });
};

LeavesReportMediator.prototype.cancelAllPDFExportingProcesses = function()
{
    if (this.pdfGenerator)
        this.pdfGenerator.interruptGeneration();
    this.pdfPreviewLightbox.cancelAllExportingProcesses();
};

LeavesReportMediator.prototype.getReportType = function()
{
    return ReportType.LEAVE_TIME;
};

LeavesReportMediator.prototype.initEditConfigController = function(config)
{
    const self = this;
    const controller =  new LeavesReportEditConfigController();
    controller.setState({
        loggedInUserId: config.loggedInUserId
    });
    controller.init(
            {
                leavesData: config.leavesData,
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                reportParameters: config.reportParameters,
                users: config.users,
                manageableUsersIds: ATReportsStore.getManageableUserIds(),
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                changeCallback: function() { self.changeParametersCallback(); },
                productSettingsValidator: config.productSettingsValidator,
                reportRightsValidator: config.reportRightsValidator
            });

    return controller;
};

// override for date range selector
LeavesReportMediator.prototype.createDateRangeSelector = function(reportParameters)
{
    const dateRangeMenuItemsUtil = new DateRangeMenuItemsUtil();
    const futureValidator = function()
    {
        return dateRangeMenuItemsUtil.isShowTTFItems(reportParameters.dateRangeSelection.qualifier);
    };

    const dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateRangeSelection,
        menuStates: dateRangeMenuItemsUtil.createDateRangeMenuItemsWithFuture(futureValidator), //for future items
        dateRangeParsed: true,
        callOnChangeCallbackIfInvalid: true
    };

    return new DateRangeSelectorController().init(dateRangeSelectorConfig);
};

LeavesReportMediator.prototype.initPrintableHeadersBuilder = function(config) {
    this.reportConfig = config
    return new ReportPrintableHeadersBuilder().init({
            users: config.users,
            reportParameters: config.reportParameters,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            leaveTypesMap: arrayToMap(config.leavesData),
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
        }
    )
}

LeavesReportMediator.prototype._populateHeadersArray = function(headersArray)
{
    this.printableHeadersBuilder.addStaffSelectionParamsToArray(this.reportParameters.userSelection, headersArray); //staff
    this.printableHeadersBuilder.addLeaveTypesParamsToArray(this.reportParameters.leaveTypeSelection, this.reportParameters.columnsConfig, headersArray); //leave types
};

LeavesReportMediator.prototype.requestGenerateReport = function(successHandler)
{
    const self = this;

    function successMethod(data, textStatus, jqXHR)
    {
        if (successHandler)
            successHandler(data, textStatus, jqXHR);
        self.$exportButton.toggleClass('disabled', false);
    }

    function errorMethod(jqXHR, textStatus, errorThrown)
    {
        self.$exportButton.toggleClass('disabled', true);
        self.hideOverlay();

        if (textStatus === "rpc_sessionExpired")
            return false;

        if (textStatus === "rpc_noRights")
        {
            alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
            document.location.href = ReportConfigConstants.REPORTS_DASHBOARD_URL;
            return true;
        }

        if (textStatus === "rpc_customException")
        {
            let messageKey;
            switch (errorThrown.exception)
            {
                case "com.actimind.actitime.reports.NoRightsToManageBalancesException":
                    if (isEnabled(Feature.PTO) && isEnabled(Feature.SDB))
                        messageKey = "report.js.report_loading_error.no_rights_manage_pto_and_sick";
                    else if (isEnabled(Feature.PTO))
                        messageKey = "report.js.report_loading_error.no_rights_manage_pto";
                    else if (isEnabled(Feature.SDB))
                        messageKey = "report.js.report_loading_error.no_rights_manage_sick";
                    break;
                case "com.actimind.actitime.reports.AllSelectedUsersWereDeletedException":
                    messageKey = "report.js.report_loading_error.no_selected_users";
                    break;
                case "com.actimind.actitime.reports.AllSelectedLeaveTypesWereDeletedException":
                    messageKey = "report.js.report_loading_error.no_selected_leave_types";
                    break;
            }

            if (messageKey)
            {
                self.showReportLoadingError(messageResource.getMessage(messageKey));
                return true;
            }
        }
        else
        {
            self.showReportLoadingError(messageResource.getMessage("report.js.report_loading_error.network_error", [PRODUCT_NAME]));
            return true;
        }

        return false;
    }
    
    return makeRpcCall("LeavesReportService.getLeavesReport", [this.makeServiceParams(this.reportParameters)], successMethod, errorMethod);
};

LeavesReportMediator.prototype.validateGeneratedReport = function(data)
{
    return true;
};

LeavesReportMediator.prototype.renderGeneratedReport = function(data)
{
    const reportParams = $.extend(true, {}, this.reportParameters);
    const info = {};
    const groupingLevels = BaseReport.ConvertUtils.getGroupingLevels(reportParams);
    for (let i = 0; i < data["groupingLevelsInfoLists"].length; ++i)
    {
        const groupingType = BaseReport.ConvertUtils.getGroupingType(i, groupingLevels);
        info[groupingType] = arrayToMap(data["groupingLevelsInfoLists"][i]);
    }

    LeavesReportStore.setReportData(data["rootItem"], info);
    LeavesReportStore.mergeGeneralStore(ATReportsStore);
    LeavesReportStore.setReportParams(reportParams);
    LeavesReportStore.setDefaultWorkDayDuration(data["defaultWorkDayDuration"]);

    if (this.leavesReportTable)
        this.leavesReportTable.cancelRendering();

    this.reportPlaceholder.empty();
    this.leavesReportTable = new LeavesReport.Table(this.reportPlaceholder, LeavesReportStore).init();
    this.leavesReportTable.update();
};


// WEBPACK FOOTER //
// ./web/js/reports/LeavesReportMediator.js